import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import AuthorizedContact from '../components/AuthorizedContact'
import ErrorNotification from '../components/ErrorNotification'
import CompanyDetails from '../components/CompanyDetails'
import ButtonComponent from '../components/ButtonComponent'
import '../assests/scss/signupPpage.scss';
import useStateCallback from '../components/common/useStateCallback'
import { basicDetails, getApiData, postApiCall,getCountry } from '../actions/corporateSignupAction';
import { useNavigate } from 'react-router-dom';
import LoaderSpinner from '../components/LoaderSpinner'
import { useDispatch } from "react-redux";
import YourColleaguesInvite from "../components/YourColleaguesInvite"
import CheckboxComponent from '../components/fields/CheckboxComponent'
const buttonEnable = false
let countryCode
const CorporateSignup = (props) => {

    const tracking = () => {
        if (!window['sasD360DataLayer']) {
            (window).sasD360DataLayer = [];
        }
        window['sasD360DataLayer'].push({
            event: 'interaction',
            'interaction.category': 'SAS For Business', 
            'interaction.action': 'Manual signup link click',
            'interaction.label': 'Tracking Manual signup link clicked'
        });
        window.location.href = "https://www.flysas.com/en/corporate-program/become-corporate-customer/";
    }
    useEffect(() => {
       // loadScriptInitiate()
        props.getCountry();
    }, []);
    
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { steps: stepPageNo, triggerPage: setStepPageNo, triggerErrorMsg: setErrorNotificationmsg } = props.pageDetails;

    const [states, setStates] = useStateCallback({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        country: '',
        org: '',
        termAndCondition: false,
        captcha: ''
    })
    const [errorMsg, setErrorMsg] = useStateCallback({
        firstName: false,
        lastName: false,
        email: false,
        phone: false,
        country: false,
        org: false,
        termAndCondition: false,
        captcha: false
    })
    
    const [enableAutomatedSignup, setenableAutomatedSignup] = useState(true)
    const [enableCompanyInfo, setEnableCompanyInfo] = useState()
    const [orgNumberLength, setorgNumberLength] = useState(false)
    const [loader, setLoader] = useState(false)
    const [loaderWithMsg, setLoaderWithMsg] = useState(false)
    const [CompanyAllreadyConnected, setCompanyAllreadyConnected] = useState(false)
    const [orgNoInvalid, setOrgNoInvalid] = useState(false)
    const [backToStartPage, setBackToStartPage] = useState(false)
    const [companyInofoMissing, setcompanyInofoMissing] = useState(false)
    const [enableCompanyDetailsPage, setEnableCompanyDetailsPage] = useState(true)
    const [companyDetailsResponse, setcompanyDetailsResponse] = useState()
    
    // const loadScriptInitiate = () => {
    //     const locationHostName = window.location.hostname;
    //     const url = (locationHostName.indexOf('localhost') > -1 || locationHostName.indexOf('test') > -1) ? 'https://components.test.flysas.com/v2/cms-s4s-elements/partials/analytics/tagmanager.js' : 'https://components.flysas.com/v2/cms-s4s-elements/partials/analytics/tagmanager.js';
    //     console.log('preparing to load...')
    //     let node = document.createElement('script');
    //     node.src = url;
    //     node.type = 'text/javascript';
    //     node.async = true;
    //     node.charset = 'utf-8';
    //     document.getElementsByTagName('head')[0].appendChild(node);

    // }
    const startFromFirstPage = () => {
        setEnableCompanyInfo();
        setEnableCompanyDetailsPage(true)
        setBackToStartPage(false)

    }
  
    const callBackPreviousPage = () => {
        if(stepPageNo === 0 && enableCompanyInfo) {
         setEnableCompanyDetailsPage(true)
         setEnableCompanyInfo('')
        }
    }
    callBackPreviousPage();
    useEffect(() => {
        
        dispatch({
            type: 'PARTIALSUCCESS',
            payload: false
        })
        loadManualSignupPage()
        countryCode = getMarketByHref().split("-")[0];
        setStates(c => ({
            ...c,
            country: getMarketByHref().split("-")[0],
            phone: getMarketByHref().split("-")[0].toUpperCase()  === 'SE' ? '+46' : getMarketByHref().split("-")[0].toUpperCase()  === 'NO' ? '+47': '+45'
            
        }))
    }, []);
    const loadManualSignupPage = () => {
        //console.log(enableAutomatedSignup)
        //console.log(getMarketByHref().split("-")[0], 'market',props.getSessionStorage);
        if ((getMarketByHref().split("-")[0] === 'se' || getMarketByHref().split("-")[0] === 'no' || getMarketByHref().split("-")[0] === 'dk') && enableAutomatedSignup) {
            if (!props.getSessionStorage) {
                window.location.href = '/customer-integrations/#/corporate-signup'
            } 

        } else if (!enableAutomatedSignup) {
            otherMarketManualFlow()
            if (getMarketByHref().split("-")[0] === 'no') {
                window.location.href = `/bedriftsprogram/bli-bedriftskunde/`
            } 
            // if (getMarketByHref().split("-")[0] === 'se') {
            //     window.location.href = `/foretagsprogram/bli-foretagskund/`
            // } else if (getMarketByHref().split("-")[0] === 'no') {
            //     window.location.href = `/bedriftsprogram/bli-bedriftskunde/`
            // } else if (getMarketByHref().split("-")[0] === 'dk') {
            //     window.location.href = `/virksomhedsprogram/bliv-virksomhedskunde/`
            // }
        } else {
            otherMarketManualFlow()
        }
    }

    const otherMarketManualFlow = () => {
        if (getMarketByHref().split("-")[1] === 'zh' || getMarketByHref().split("-")[1] === 'ja' || getMarketByHref().split("-")[1] === 'ru' || (getMarketByHref().split("-")[1] === 'en' && window.location.hostname !== "localhost")) {
            if (getMarketByHref().split("-")[0] === 'lu') {
                window.location.href = `/en/corporate-program/become-corporate-customer`
            } else {
                window.location.href = `/${getMarketByHref()}/corporate-program/become-corporate-customer`
            }


        } else if (getMarketByHref().split("-")[1] === 'de') {
            window.location.href = `/${getMarketByHref()}/firmenprogramm/firmenkunde-werden`
        } else if (getMarketByHref().split("-")[1] === 'es') {
            window.location.href = `/${getMarketByHref()}/programa-corporativo/hagase-socio-corporativo`
        } else if (getMarketByHref().split("-")[1] === 'fr') {
            window.location.href = `/${getMarketByHref()}/programme-entreprise/devenir-un-client-professionnel`
        }
    }
    const useMyAccountInformation = (event) => {
        setStates(c => ({
            ...c,
            firstName: event.target.checked ? props.getSessionStorage['firstName'] ? props.getSessionStorage['firstName'] : '' : '',
            lastName: event.target.checked ? props.getSessionStorage['lastName'] ? props.getSessionStorage['lastName'] : '' : '',
            email: event.target.checked ? props.getSessionStorage['emailId'] ? props.getSessionStorage['emailId'] : '' : '',
            phone: event.target.checked ? props.getSessionStorage['phone'] ? props.getSessionStorage['phone'] : '' : ''
        }))
        setErrorMsg(c => ({
            ...c,
            firstName: states.firstName ? true : false,
            lastName: states.lastName ? true : false,
            email: states.email ? true : false,
            phone: states.phone ? true : false,
        }))
        event.target.checked ? onFocusInput('checked') : onFocusInput('unchecked')
    }

    const [focused, setFocused] = useStateCallback({
        firstName: false,
        lastName: false,
        email: false,
        phone: false,
        country: false,
        org: false,
        termAndCondition: false,
        captcha: false
    })
    const onFocusInput = (event) => {
        if (event === 'checked' || event === 'unchecked') {
            setFocused(c => ({
                ...c,
                firstName: event === 'checked' ? true : false,
                lastName: event === 'checked' ? true : false,
                email: event === 'checked' ? true : false,
                phone: event === 'checked' ? true : false,
            }))

        } else {
            setFocused(c => ({
                ...c,
                [event.target.name]: event.target.value === '' ? true : event.target.value !== '' ? true : true
            }))
        }
            if (event.target.name === 'phone') {
                const value = event.target.value.replace(/\D/g, "");
                event.target.value = value
                formatPhonenumber(event)
                return true
            }

    }
    const onBlurInput = (event) => {
        setFocused(c => ({
            ...c,
            [event.target.name]: event.target.value === '' ? false : true
        }))
    }

    const onChangeInput = (event) => {

        validation(event)
        setStates(c => ({
            ...c,
            [event.target.name]: (event.target.name === 'termAndCondition') ? event.target.checked : event.target.value,
        }))
        setErrorMsg(c => ({
            ...c,
            [event.target.name]: ((event.target.name === 'termAndCondition' && event.target.checked) || (event.target.value && validation(event))) ? false : true
        }))

    }
    const onchangeCountry = (event) => {
        setorgNumberLength(false)
        countryCode = event.target.value;
        setStates(c => ({
            ...c,
            [event.target.name]: event.target.value,
            org: ''
        }))
        setFocused(c => ({
            ...c,
            org: false,

        }))
    }
    const onChangeCaptch = (event) => {
        setStates(c => ({
            ...c,
            captcha: event,
        }))
        setErrorMsg(c => ({
            ...c,
            captcha: !states.captcha ? false : true,
        }))
    }
    const validation = (event) => {
        if (event.target.name === 'firstName' || event.target.name === 'lastName') {
            const value = event.target.value.replace(/[^a-zA-ZÀ-úüÜ\s]/g, '');
            event.target.value = value
            if (value.length >= 2 && value.length <= 30) {
                return true
            }
        }

        if (event.target.name === 'email') {
            const result = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return result.test(String(event.target.value).toLowerCase());
        }
        if (event.target.name === 'phone') {
            const value = event.target.value.replace(/\D/g, "");
            event.target.value = value
            formatPhonenumber(event)
            if (value.length >= 8) {
                return true
            }
        }
        if (event.target.name === 'org') {
            setorgNumberLength(typeof formatOrgNumber(event) === 'boolean' ? formatOrgNumber(event) : false)
            return formatOrgNumber(event)
        }
    }
    const getMarketByHref = () => {
        const href = window.location.href
        if (href.match(/.+\.sas\.se/)) {
            return "se-sv"
        } else if (href.match(/.+\.sas\.no/)) {
            return "no-no"
        } else if (href.match(/.+\.sas\.dk/)) {
            return "dk-da"
        } else if (href.match(/.+\.sas\.fi/)) {
            return "fi-en"
        } else if (href.match(/\/resmal\//)) {
            return "se-sv"
        } else if (href.match(/\/reisemal\//)) {
            return "no-no"
        } else if (href.match(/\/rejsemaal\//)) {
            return "dk-da"
        }
        return getMarketByPathname(href).toLowerCase()
    }
    const getMarketByPathname = (href) => {
        return (href.match(/\/([a-z]{2}-[a-z]{2})(\/|$).*/i) || [])[1] || "se-sv"
    }
    const formatOrgNumber = (event) => {
        if (!event.target.value) return event.target.value;
        const orgNumber = event.target.value.replace(/[^\d]/g, '');
        const orgNumberLength = orgNumber.length;
        if (orgNumberLength < 4) return orgNumber;
        if (countryCode.toUpperCase() === 'DK') {
            event.target.value = orgNumberLength < 7 ? `DK${orgNumber.slice(0, 8)}${orgNumber.slice(8)}` : `DK${orgNumber.slice(0, 8)}${orgNumber.slice(8, 8)}`;
            return orgNumberLength === 8 ? true : false
        } else if (countryCode.toUpperCase() === 'NO' || countryCode === 'lu') {
            const orgNumberLength = orgNumber.length;
            event.target.value = orgNumberLength < 7 ? `${orgNumber.slice(0, 3)} ${orgNumber.slice(3)}` : `${orgNumber.slice(0, 3)} ${orgNumber.slice(3, 6)} ${orgNumber.slice(6, 9)}`;
            return orgNumberLength === 9 ? true : false
        } else if (countryCode.toUpperCase() === 'SE') {
            event.target.value = orgNumberLength < 7 ? `${orgNumber.slice(0, 6)}${orgNumber.slice(6)}` : `${orgNumber.slice(0, 6)}-${orgNumber.slice(6, 10)}`;
            return orgNumberLength === 10 ? true : false
        }
    }
    const formatPhonenumber = (event) => {
        if (!event.target.value) return event.target.value;
        if (countryCode.toUpperCase() === 'DK') {
            event.target.value = `+45 ${event.target.value.replace(/45/i, '').slice(0, 12)}`;
        } else if (countryCode.toUpperCase()=== 'NO' || countryCode === 'lu') {
            event.target.value = `+47 ${event.target.value.replace(/47/i, '').slice(0, 12)}`;
        } else if (countryCode.toUpperCase()  === 'SE') {
            event.target.value = `+46 ${event.target.value.replace(/46/i, '').slice(0, 12)}`;
        }
    }

    const cookieLogin = () => {
        return isDevEnvironment()
            ? 'eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX25hbWUiOiJzYW1wbGUuY29tcGFueUBnbWFpbC5jb20iLCJzY29wZSI6WyJyZWFkIiwid3JpdGUiXSwiY3VzdG9tZXJTZXNzaW9uSWQiOiI0MDRmMjQyMzBiODk0ZmM1ODQxMjgwYTJmMTJhNjRjMSIsInNlc3Npb25JZCI6IjEyMTY5NzQ1LDIwMjItMTEtMDMgMTE6MDk6NTgsMzAsMTAsUjRUbVIwOTVRZEpSSVpBRkx4dUdJRGRuNUFFYUdnU1JvaDUvRGlGYWdjblVWN2RlSlE4OWwxRllRL1h4NDBnbyIsImV4cCI6MTY2NzY1Mzc5OCwiYXV0aG9yaXRpZXMiOlsiUk9MRV9VU0VSIl0sImp0aSI6IjE2Y2E4NTNiLTI2MDYtNDA2ZS1iY2JjLWJlNzNiOWFiNWFkOSIsImNsaWVudF9pZCI6IlNBUy1VSSJ9.3fbOiHb7JiUpRvYqrfCh-BF418eb4Ubp3-17m-lPpy0'
            : getCookie('LOGIN_AUTH')
    }

    const getCookie = (name) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop().split(";").shift()
    }
    const isDevEnvironment = () => {
        return (
            window.location.hostname === "localhost" ||
            window.location.hostname.match(/\.local/) ||
            window.location.hostname.match(/^10\..+/)
        )
    }
    const isTestEnvironment = () => {
        return !!window.location.hostname.match(/test\./)
    }
    const apiPath = () => {
        return isDevEnvironment() || isTestEnvironment()
            ? "https://api2.test.flysas.com"
            : "https://api2.flysas.com"
    }
    const getCompanyDetails = (orgNo) => {
        const req = {
            url: `${apiPath()}/corporate/companydetails/${orgNo}`,
            headers: {
                'Authorization': cookieLogin(), 'countrycode': countryCode,//getMarketByHref().split("-")[0], 
                'captcha': states.captcha,
                "content-type": "application/json"
            },
        }
        return new Promise((resolve, reject) => {
            getApiData(req)
                .then(data => {
                    resolve(data)
                   // console.log(data, 'response data')
                    setLoader(false)
                    if (data.errors) {
                        if (data.errors[0].errorCode === '1000041') {
                            setEnableCompanyDetailsPage(false)
                            setCompanyAllreadyConnected(true)
                            setBackToStartPage(true)
                        } else if (data.errors[0].errorCode === '1000040') {
                            setEnableCompanyDetailsPage(false)
                            setOrgNoInvalid(true)
                            setBackToStartPage(true)
                        } else {
                            setErrorNotificationmsg(props.labels[`corporatesignupError.${data.errorInfo[0].errorCode}`])
                        }

                    } else {
                        // if(data.company[0].address && data.company[0].name  &&  data.company[0].county && data.company[0].town &&  data.company[0].zipCode) {
                        if(data.company[0].address && data.company[0].name && data.company[0].town &&  data.company[0].zipCode) {
                            setcompanyDetailsResponse(data)
                            setStepPageNo(1)
                            setEnableCompanyInfo(data);
                            setEnableCompanyDetailsPage(false)
                        } else {
                            setBackToStartPage(true)
                            setcompanyInofoMissing(true)
                        }
                        
                    }

                })
                .catch(error => {
                    setLoader(false)
                    setErrorNotificationmsg(props.labels[`corporatesignupError.1000042`])
                    logError(error)
                    reject(error)
                })
        })
    }
    const updateProfileSession = (data) => {
        const profSession = JSON.parse(sessionStorage.getItem('prof-profile'));
        if (profSession) {
            profSession['smartLinks'] = data;
            sessionStorage.setItem('smartLinks', JSON.stringify(data));
            sessionStorage.setItem('prof-profile', JSON.stringify(profSession));
        } else {
            sessionStorage.setItem('smartLinks', JSON.stringify(data));
        }
    }
    const joinNow = () => {
        const req = {
            url: `${apiPath()}/corporate/registercompanydetails`,
            headers: {
                'Authorization': cookieLogin(), 'countrycode':countryCode, // getMarketByHref().split("-")[0],
                "content-type": "application/json"
            },
            body: JSON.stringify({
                firstName: states.firstName,
                lastName: states.lastName,
                emailId: states.email,
                phoneNumber: states.phone,
                orgNumber: companyDetailsResponse.company[0].id,
                companyName: companyDetailsResponse.company[0].name,
                address: companyDetailsResponse.company[0].address,
                town: companyDetailsResponse.company[0].town,
                zipCode: companyDetailsResponse.company[0].zipCode,
                webAddressReg: companyDetailsResponse.company[0].webAddressReg,
                emailReg: companyDetailsResponse.company[0].emailReg,
                phoneNumberReg: companyDetailsResponse.company[0].phoneNumberReg,
                countryCode: countryCode,
                countryName: countryCode.toUpperCase() === 'SE' ? 'Sweden' : countryCode.toUpperCase() === 'NO' ? 'Norway' : 'Denmark',
            })
        }
        return new Promise((resolve, reject, ) => {
            postApiCall(req)
                .then(data => {
                    // setLoader(false)
                    resolve(data)
                  //  console.log(data, 'response data')
                    setLoader(false)
                    setLoaderWithMsg(false)
                    if (data.errorInfo) {
                        if (data.errorInfo[0].errorCode === 1000045 || 1000046 || 1000047 || 1000049) {
                            dispatch({
                                type: 'PARTIALSUCCESS',
                                payload: true
                            })
                            setStepPageNo(3)
                            navigate('/corporate-signup-success')
                        } else {
                            setErrorNotificationmsg(props.labels[`corporatesignupError.${data.errorInfo[0].errorCode}`])
                        }
                    } else {
                        dispatch({
                            type: 'PARTIALSUCCESS',
                            payload: 'false'
                        })
                        updateProfileSession(data)
                        dispatch({
                            type: 'CONNCETD_RESPONSE',
                            payload: data
                        })
                        setStepPageNo(3)
                        navigate('/corporate-signup-success')

                    }

                })
                .catch(error => {
                 //   console.log(error, 'error while register')
                    setLoader(false)
                    setLoaderWithMsg(false)
                    setErrorNotificationmsg(props.labels[`corporatesignupError.1000042`])
                    logError(error)
                    reject(error)
                })
        })
    }

    const logError = error => {
        console.error(error)
    }
    const backToStart = () => {
        window.location.href = '/'
    }
    const formValid = () => {
       // console.log(stepPageNo, 'form validate')


        if (stepPageNo === 0) {

            if (states.org  && states.captcha && states.termAndCondition) {
                setLoader(true)
                getCompanyDetails(states.org.replace(/[^0-9.]/g, ''))

            } else {
                setErrorMsg(c => ({
                    ...c,
                    org: !states.org ? true : false,
                    captcha: !states.captcha ? true : false,
                    termAndCondition: !states.termAndCondition ? true : false,
                }))

            }


        } else if (stepPageNo === 1) {
            if (states.termAndCondition) {

                setStepPageNo(2)

            } else {
                setErrorMsg(c => ({
                    ...c,
                    termAndCondition: !states.termAndCondition ? true : false,
                }))

            }



        } else if (stepPageNo === 2) {
            if (states.email !== '' && states.phone !== '' && states.firstName !== '' && states.lastName !== '') {
                // setLoader(true)
                setLoader(true)
                joinNow()
                setLoaderWithMsg(true)
                startFromFirstPage()
                setStepPageNo(2)
            } else {
                setErrorMsg(c => ({
                    ...c,
                    firstName: states.firstName === '' ? true : false,
                    lastName: states.lastName === '' ? true : false,
                    email: states.email === '' ? true : false,
                    phone: states.phone === '' || '+45' || '+46' || '+47' ? true : false,
                }))

            }

        }
    };

    return <>
        <LoaderSpinner loader={loader} loaderWithMsg={loaderWithMsg} />

        

       {stepPageNo === 0 && 
       <>
       <div className='info-wrap'>

            <div className='info-right'>
                <div className="head-title">{props.labels['corporate.signup.title']}</div>
                <div className='head-sub-title'> {props.labels['corporate.signup.description']}</div>
                <div>{props.labels['corporate.signup.description.info']}</div>
                <div className='benefits-link'><a target='_blank' className='more-link' href={getMarketByHref().split("-")[0] === 'se'? 'https://www.sas.se/foretagsprogram/' : getMarketByHref().split("-")[0] === 'no' ? 'https://www.sas.no/bedriftsprogram/': 'https://www.sas.dk/virksomhedsprogram/'}>{props.labels['corporate.signup.read.more']}</a></div>
            </div> 

            <div className='info-left'>
                <div className="signup-info">
                    <div className='list-title'>{props.labels['corporate.signup.benefits.title']}</div>
                    <div className='icons'> 
                        <div><svg class="sas-icon" role="presentation" ><use href="#cl--star"></use></svg></div>
                         <div>{props.labels['corporate.signup.benefits.point.1']}</div>
                    </div>
                    <div className='icons'>
                        <div><svg class="sas-icon" role="presentation" ><use href="#cl--biofuel"></use></svg></div>
                        <div>{props.labels['corporate.signup.benefits.point.2']}</div>
                    </div>
                    <div className='icons'>
                        <div><svg class="sas-icon" role="presentation" ><use href="#cl--eb-card"></use></svg></div>
                        <div>{props.labels['corporate.signup.benefits.point.3']}</div>
                    </div>
                    <div className='icons'>
                        <div><svg class="sas-icon" role="presentation" ><use href="#cl--tp-ticket"></use></svg></div>
                        <div>{props.labels['corporate.signup.benefits.point.4']}</div>
                    </div>
                </div>
            </div>
       </div>
       
       
       
        </>}
        {/* <YourColleaguesInvite/> */}
        <div className='inner-wrapper'>
            {/* {stepPageNo === 0 && <div>{props.labels['corporate.signup.description']}</div>} */}

            {(stepPageNo === 0 || stepPageNo === 1) && props.countryName.countries?.length > 0 ?
                <CompanyDetails inputs={states} onChangeInput={onChangeInput} onBlurInput={onBlurInput} onFocusInput={onFocusInput} focused={focused} errorMsg={errorMsg} useMyAccountInformation={useMyAccountInformation} orgNumberLength={orgNumberLength} onChangeCaptch={onChangeCaptch} onchangeCountry={onchangeCountry} country={getMarketByHref().split("-")[0]} language={getMarketByHref().split("-")[1]} enableCompanyDetailsPage={enableCompanyDetailsPage} enableCompanyInfo={enableCompanyInfo} orgNoInvalid={orgNoInvalid} CompanyAllreadyConnected={CompanyAllreadyConnected} states={states} listOfCounties ={props.countryName} companyInofoMissing={companyInofoMissing} backToStart={backToStart}/>

                : stepPageNo === 2 ?
                    <AuthorizedContact inputs={states} onChangeInput={onChangeInput} onBlurInput={onBlurInput} onFocusInput={onFocusInput} focused={focused} errorMsg={errorMsg} useMyAccountInformation={useMyAccountInformation} /> : ''
            }
            
            {!backToStartPage && <>
                <div className= 'terms-cond '>
                <div className='terms'>
                        <CheckboxComponent invalid={errorMsg.termAndCondition ? 'invalid' : ''} value={states.termAndCondition} onClickFunction={onChangeInput} error={props.labels['corporate.signup.error.tems.and.condition']} label={props.labels['corporate.signup.accepted']} link="https://assets.ctfassets.net/oz9qk43ly6yk/3428ZhpWiLQfvLYN6gGeD/b442061d250813f3c04e2038f334a6de/sme-sas-for-work-en.pdf" linktext={props.labels['corporate.signup.terms.and.conidtion']} name="termAndCondition" id="termAndCondition"  />
                    </div>
            <ButtonComponent label={stepPageNo === 2 ? props.labels['corporate.signup.button.join'] : props.labels['corporate.signup..next.button']} buttonEnable={buttonEnable} onAction={formValid} />
            </div></>}

            {backToStartPage && <>

            <ButtonComponent label={props.labels['corporate.signup.button.join']} onAction={backToStart} />
         
 
            </>}
        </div>
    </>

}
const mapStateFromReducer = (state) => ({
    ...state,
    labels: state.corporateSignupReducer.labels || {},
    getSessionStorage: state.corporateSignupReducer.getSessionStorage || {},
    countryName: state.corporateSignupReducer.country || {},
})

const mapDispatchToActions = (dispatch) => ({
    getCountry: (requestBody) => dispatch(getCountry(requestBody)),
    basicDetails: (body) => dispatch(basicDetails(body)),
    getApiData: (req) => dispatch(getApiData(req)),
    postApiCall: (req) => dispatch(postApiCall(req))
})

export default connect(
    mapStateFromReducer,
    mapDispatchToActions
)(CorporateSignup);
